import { ControllerRenderProps, ControllerFieldState } from 'react-hook-form';

/**
 * Maps RHF's field/fieldState to the `field` prop shape that
 * DefaultTextField and DefaultPatientTextField expect (legacy redux-form shape).
 */
export function toReduxFormField(
  field: ControllerRenderProps<any, string>,
  fieldState: ControllerFieldState,
  extraProps: Record<string, unknown> = {},
) {
  return {
    input: {
      name: field.name,
      value: field.value ?? '',
      onChange: field.onChange,
      onBlur: field.onBlur,
      onFocus: () => {},
    },
    meta: {
      pristine: !fieldState.isDirty,
      dirty: fieldState.isDirty,
      error: fieldState.error?.message,
    },
    ...extraProps,
  };
}
